import React, { useState, useEffect } from 'react'
import { SpinnerWrapper, SpinnerLoader, MessageWrapper } from './style'

import style from './Spinner.css'

const Spinner = ({
  autoMargin,
  noMargin,
  isAbsolute,
  isBasic = true,
  smallerSize,
  styles,
  messages = [],
  interval = 3000,
  marginTop = '0px',
  justifyContent = 'center',
}) => {
  const [message, setMessage] = useState(messages?.length ? messages[0] : '')

  const changeMessage = index => {
    setMessage(messages[index])
  }

  useEffect(() => {
    let index = 0
    let timer = null
    timer = setInterval(() => {
      if (index < messages?.length - 1) {
        index = index + 1
        changeMessage(index) // IN ORDER TO AVOID REPEATING MESSAGES
      }
    }, interval)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <SpinnerWrapper
      $noMargin={noMargin}
      $autoMargin={autoMargin}
      $isAbsolute={isAbsolute}
      $isBasic={isBasic}
      style={styles}
      $justifyContent={justifyContent}
    >
      <SpinnerLoader
        $smallerSize={smallerSize}
        className={'spinner'}
        $marginTop={marginTop}
      ></SpinnerLoader>
      {messages?.length ? (
        <MessageWrapper>{message || ''}</MessageWrapper>
      ) : null}
    </SpinnerWrapper>
  )
}

export default Spinner
